'use client'

import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react'

type CartDrawerContextValue = {
  isOpen: boolean
  setIsOpen: (open: boolean) => void
  openCartDrawer: () => void
  closeCartDrawer: () => void
}

const CartDrawerContext = createContext<CartDrawerContextValue | null>(null)

export function CartDrawerProvider({ children }: { children: React.ReactNode }) {
  const [isOpen, setIsOpen] = useState(false)

  const openCartDrawer = useCallback(() => setIsOpen(true), [])
  const closeCartDrawer = useCallback(() => setIsOpen(false), [])

  const value = useMemo(
    () => ({ isOpen, setIsOpen, openCartDrawer, closeCartDrawer }),
    [isOpen, openCartDrawer, closeCartDrawer]
  )

  return (
    <CartDrawerContext.Provider value={value}>
      {children}
    </CartDrawerContext.Provider>
  )
}

export function useCartDrawer() {
  const ctx = useContext(CartDrawerContext)
  if (!ctx) {
    throw new Error('useCartDrawer must be used within CartDrawerProvider')
  }
  return ctx
}
